module.exports = __webpack_public_path__ + "static/media/tt.50266f50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/tt.png
// module id = 2004
// module chunks = 0